import { render } from "./CancellationFlow.vue?vue&type=template&id=5d99df0b&scoped=true"
import script from "./CancellationFlow.vue?vue&type=script&lang=js"
export * from "./CancellationFlow.vue?vue&type=script&lang=js"

import "./CancellationFlow.vue?vue&type=style&index=0&id=5d99df0b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d99df0b"]])

export default __exports__